export class SnappingConfig {
  mode: string;
  snapTo: string;
  tolerance: number;
  selectedLayers: string[];
}
